import '.l{display:flex;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.bl{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.bm{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.b2{align-items:stretch;}.ssr-plugin'
import '.bn{margin-top:2rem;}.ssr-plugin'
import '.bo{margin-bottom:5rem;}.ssr-plugin'
import '.bp{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="l aa a1 m bl"
      >
        <DashboardNavBar />
        <div className="bm l m b2 bn bo bp"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
